import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_INGREDIENT_SPECIAL_CASE_MUTATION } from '../graphql/mutations'
import { DELETE_INGREDIENT_SPECIAL_CASE } from '../redux/action-types'

const useDeleteIngredientSpecialCaseMutation = () => {
  const dispatch = useDispatch()

  const { isLoading, error, idToDelete } = useSelector(
    store => store.ingredients.ingredientSpecialCases,
  )

  const mutate = useCallback(
    id =>
      apolloService.mutate(
        DELETE_INGREDIENT_SPECIAL_CASE_MUTATION,
        { id },
        dispatch,
        DELETE_INGREDIENT_SPECIAL_CASE,
      ),
    [dispatch],
  )

  return [mutate, { isLoading, error, idToDelete }]
}

export default useDeleteIngredientSpecialCaseMutation
